'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var ProgressBar_web_styles = require('./ProgressBar.web.styles.cjs');

/**
 *
 * This component is used to display the progress of a task
 * {@link https://aviary.supernova-docs.io/latest/components/progress-bar/overview-QPZC0C5a | Documentation}
 *
 * @scope Core
 */ const ProgressBar = ({ progress, "aria-label": ariaLabel, customCss, ...rest })=>{
    const trueProgress = Math.min(100, Math.max(0, progress));
    const isBarFull = trueProgress === 100;
    const barStyles = [
        ProgressBar_web_styles.bar.base,
        isBarFull && ProgressBar_web_styles.bar.full
    ];
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: [
            ProgressBar_web_styles.container,
            customCss
        ],
        ...rest,
        children: /*#__PURE__*/ jsxRuntime.jsx("div", {
            role: "progressbar",
            "aria-valuenow": trueProgress,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-label": ariaLabel,
            css: barStyles,
            style: {
                width: `${trueProgress}%`
            }
        })
    });
};

exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.web.cjs.map
